var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"currentcolor","d":"M225.9,354.7c-8.1,0-16.2-3.1-22.4-9.3L9.3,151.2c-12.4-12.4-12.4-32.4,0-44.8c12.4-12.4,32.4-12.4,44.7,0\n\t\t\tl171.9,171.9l171.9-171.9c12.4-12.4,32.4-12.4,44.7,0c12.4,12.4,12.4,32.4,0,44.8L248.3,345.4C242.1,351.6,234,354.7,225.9,354.7z"})));
}

ArrowDown.defaultProps = {"className":"svg-icon","version":"1.1","viewBox":"0 0 451.8 451.8","style":{"enableBackground":"new 0 0 451.8 451.8"},"xmlSpace":"preserve"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
